<header
	class="login-header"
	[ngClass]="{
		'login-header--only-for-mobile': context === 'only-for-mobile',
		'login-header--ad-slider': context === 'ad-slider',
	}"
>
	<a
		class="login-header__logo"
		[href]="SETTINGS.URLS.LOGO_LINK"
		target="_blank"
	>
		<app-svg-rsb-logo-text-line-two [fillColor]="logoColor"></app-svg-rsb-logo-text-line-two>
	</a>
</header>
